import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EmergencyCardService } from 'src/app/_services/emergency-card.service';
import { showNotification } from 'src/app/helpers/show-toast';

@Component({
  selector: 'app-emergency-card',
  templateUrl: './emergency-card.component.html',
  styleUrls: ['./emergency-card.component.css']
})
export class EmergencyCardComponent implements OnInit {
  emergencyCardFrom = new FormGroup({
    numbers: new FormControl(null, [Validators.required, Validators.max(500), Validators.maxLength(3), Validators.min(1)])
  })
  constructor(private emergencyCardService: EmergencyCardService, private toastr: ToastrService) { }

  ngOnInit() {
  }
  generateEmergencyCard() {
    this.emergencyCardService.generateEmergencyCard(this.emergencyCardFrom.value.numbers).subscribe({
      next: (res: any) => {
        showNotification('success', res.message, this.toastr)
      },
      error: (error: any) => {
        showNotification('danger', error.message, this.toastr)
      },
      complete: () => {
        this.emergencyCardFrom.reset();
      }
    });
  }
}
